/**
 * VERDENSTORE v2.0 — Animation Engine
 * Scroll reveals, parallax, micro-interactions
 */
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ─── Scroll Reveal ───
  if (!prefersReduced && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));
  }

  // ─── Parallax Images ───
  if (!prefersReduced) {
    const parallaxEls = document.querySelectorAll('[data-parallax]');
    if (parallaxEls.length) {
      window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset;
        parallaxEls.forEach(el => {
          const speed = parseFloat(el.dataset.parallax) || 0.5;
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            el.style.transform = `translateY(${(scrolled - el.offsetTop) * speed * 0.1}px)`;
          }
        });
      }, { passive: true });
    }
  }

  // ─── Counter Animation ───
  document.querySelectorAll('[data-counter]').forEach(el => {
    const target = parseInt(el.dataset.counter);
    const duration = 2000;
    const start = performance.now();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animate();
          observer.unobserve(el);
        }
      });
    });
    observer.observe(el);

    function animate() {
      const now = performance.now();
      const progress = Math.min((now - start) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(ease * target);
      if (progress < 1) requestAnimationFrame(animate);
    }
  });

  // ─── Reading Progress Bar ───
  const progressBar = document.querySelector('[data-reading-progress]');
  if (progressBar) {
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / docHeight) * 100;
      progressBar.style.width = progress + '%';
    }, { passive: true });
  }

  // ─── Sticky Add to Cart ───
  const stickyATC = document.querySelector('[data-sticky-atc]');
  const productForm = document.querySelector('[data-product-form]');
  if (stickyATC && productForm) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyATC.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(productForm);
  }
});
